import Component from './thank-you'

export default Component